__webpack_require__.p = "/tanjid-alam-kabbo/";